import React from 'react'
import { useHistory } from 'react-router-dom'
import { connections } from '../../../../../api/integrations'
import Loading from '../../../../molecules/Loading'
import EmptySection from '../../../../atoms/EmptySection'
import OperationalTable from '../../../../organisms/OperationalTable'

const columns = [
  { id: 'connectionRequestId', Header: 'ID', accessor: 'connectionRequestId' },
  { id: 'code', Header: 'Code', accessor: 'code' },
  { id: 'displayName', Header: 'Name', accessor: 'displayName' },
  { id: 'domain', Header: 'Domain', accessor: 'domain' }
]

function AdminRequestsHomeIndex () {
  const { data, isLoading } = connections.useGetOutstandingIntegrationConnectionRequests()
  const history = useHistory()

  if (isLoading) {
    return (
      <Loading />
    )
  }

  if (!data?.connectionRequests?.length) {
    return (
      <EmptySection title='No Requests' description='There are no outstanding connection requests' />
    )
  }

  return (
    <div className='flex flex-col gap-lg'>
      <div className='font-size-lg'>Outstanding Connection Requests</div>
      <OperationalTable
        mode='client'
        columns={columns}
        defaultSort={[]}
        data={data?.connectionRequests || []}
        onRowClick={(item) => history.push(`/admin/requests/item/${item.original.connectionRequestId}`)}
        itemName='Requests'
        loading={isLoading}
        total={data?.connectionRequests?.length || 0}
      />
    </div>
  )
}

export default AdminRequestsHomeIndex
